module.exports = __webpack_public_path__ + "static/people_img19-756460b03a9a0c6c63759f19dbf9aa2b.png";